import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Dashlet } from 'src/app/components/dashlet/component';
import { endpoints } from 'src/app/constants/endpoints';
// import {OrderApiService} from '@module/order/services/order-api-service';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Component({
    selector: 'not-sold-ballot-dashlet',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class NotSoldBallotDashlet extends Dashlet {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  protected role = 'event-admin';
  protected endpoint = endpoints.event.notSoldBallot;
  public displayedColumns = [
    'listingTitle',
    'startDate',
    'stockQuantity',
    'actions',
  ];
  pageEvent: PageEvent;

  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {
    super();
  }
}
